// Shared by instrumentation-client.ts (bootstrap) and useAuroraEnabled — kept React-free to keep the instrumentation bundle small.
export const AURORA_FLAG_CACHE_KEY = "ph_flag_cache:aurora_enabled"
